import React from 'react';
import { View, Text, StyleSheet } from 'react-native-web';
import { colors, radius } from '../theme';

export default function Badge({ label, color = 'primary' }) {
  const bgColors = {
    primary: 'rgba(99,102,241,0.15)',
    success: 'rgba(16,185,129,0.15)',
    warning: 'rgba(245,158,11,0.15)',
    danger: 'rgba(239,68,68,0.15)',
    muted: 'rgba(100,116,139,0.15)',
  };
  const textColors = {
    primary: colors.primary,
    success: colors.success,
    warning: colors.warning,
    danger: colors.danger,
    muted: colors.textMuted,
  };

  return (
    <View style={[styles.badge, { backgroundColor: bgColors[color] }]}>
      <Text style={[styles.text, { color: textColors[color] }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    paddingVertical: 3,
    paddingHorizontal: 10,
    borderRadius: 20,
    alignSelf: 'flex-start',
  },
  text: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
});
